/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Style from './AdThumbnail.module.scss';

const handleErrorImage = (e) => {
  const image = e.target;
  image.style.display = 'none';
};

const AdThumbnail = ({
  type,
  image,
  title,
  numberOfImages,
  ribbonAd,
  saveAdButton,
  adCategories,
}) => (
  <div className={Style.thumbnailWrapper}>
    <div
      className={
        type === 'agent' ? Style.thumbnailImgShop + ' ' + Style.thumbnailImg : Style.thumbnailImg
      }
    >
      {image && (
        <img
          alt={title}
          onError={handleErrorImage}
          src={image.replace('http://', '//')}
          loading="lazy"
        />
      )}
      {adCategories && adCategories.includes(1) && (
        <div className={Style.wrapperRibbon}>
          <div className={Style.ribbonAd}>Nổi bật</div>
        </div>
      )}
      {image !== '' && numberOfImages > 1 && (
        <div className={Style.imageNum}>
          <span className={Style.text}>{numberOfImages}</span>
        </div>
      )}
      {ribbonAd && ribbonAd}
    </div>
    {saveAdButton && saveAdButton}
  </div>
);

AdThumbnail.defaultProps = {
  numberOfImages: 0,
  image: '',
  title: '',
  ribbonAd: null,
  saveAdButton: null,
  adCategories: [],
};

AdThumbnail.propTypes = {
  image: PropTypes.string,
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  numberOfImages: PropTypes.number,
  ribbonAd: PropTypes.oneOfType([() => null, PropTypes.object]),
  saveAdButton: PropTypes.element,
  adCategories: PropTypes.arrayOf(PropTypes.number),
};

export default memo(AdThumbnail);
